import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../services/users.service';
import { CookieService } from 'ngx-cookie-service';
import { LoginService } from '../services/login.service'
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  submitted = false;
  userDetails: any;
  isSocket;
  pass: boolean = false;
  public token = localStorage.getItem('userAccessToken');

  constructor(private router: Router, private spinner: NgxSpinnerService, private fb: FormBuilder, private usersService: UsersService, 
    private cookie: CookieService, private loginService: LoginService, private toastr: ToastrService,) { }
  showOldPassword : boolean = false;
  showNewPassword : boolean = false;
  showConfirmPassword : boolean = false;

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.createChangePasswordFrom();
    // this.getUserMatchStackDetails()
    this.logoutListenUser();
    this.isSocket = this.cookie.get('is_socket');
    if (this.isSocket == null || this.isSocket == undefined || this.isSocket == '') {
      this.getGlobalSettings();
    }
    if(this.userDetails.is_change_password == '0'){
      this.pass = true;
    }
  }
  createChangePasswordFrom() {
    this.changePasswordForm = this.fb.group({

      old_password: ['', [Validators.required]],
      new_password: ['', [Validators.required]],
      confirm_password: ['', [Validators.required]]

    })
  }
  socketOnEvent(eventName, callback) {
    // this.socketService.socket.on(eventName, data => callback(data));
  }
  logoutListenUser() {
    this.logoutUserFromAllDevices()
    
    this.socketOnEvent(`logoutUserFromAllDevices${this.userDetails._id}`, data => {
      if (data.status == true && data.caller_identifier != this.token) {
        this.cookie.delete('userId');
        this.cookie.delete('is_socket');
        this.loginService.clearLocalStorage()
        this.router.navigate(['login'])
        window.location.reload();
        window.location.replace('login');
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastr.error(data.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
      }
    });

  }
  logoutUserFromAllDevices() {
    this.spinner.hide();
    this.socketEmitEvent('logoutUserFromAllDevices', { user_id: this.userDetails._id, caller_identifier: this.cookie.get('accessToken') });
  }
  getGlobalSettings() {

    this.usersService.getGlobalSettings().subscribe(response => {
      if (response.status == true) {
        this.cookie.delete('is_socket');
        this.cookie.set('is_socket', response.data.is_socket);
      }
    }, error => {
      console.log(error)
    })

  }

  socketEmitEvent(eventName, data) {
    // this.socketService.socket.emit(eventName, data);
  }

  logoutUser() {
    let data = {};
    this.spinner.show();
    this.loginService.logoutUser(data).subscribe(result => {
      if (result.status == true) {
        this.toastr.success(result.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        })
        this.cookie.delete('userId');
        this.loginService.clearLocalStorage()
        this.router.navigate(['login']);
        window.location.reload();
        window.location.replace('login');
        this.spinner.hide();
      } else {
        this.toastr.error(result.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
        this.cookie.delete('userId');
        this.loginService.clearLocalStorage()
        this.router.navigate(['login']);
        window.location.reload();
        window.location.replace('login');
        this.spinner.hide();
      }
    })


  }

  get f() { return this.changePasswordForm.controls; }
  onSubmitChangePassword() {
    this.submitted = true;

    if (this.changePasswordForm.invalid) {
      return;
    }
    let data = {
      "newPassword": this.changePasswordForm.value.new_password
    }

    if (this.changePasswordForm.controls['old_password'].value != this.changePasswordForm.controls['new_password'].value) {
      if (this.changePasswordForm.controls['new_password'].value == this.changePasswordForm.controls['confirm_password'].value) {
        this.usersService.changePassword(data).subscribe((result) => {
          if (result.status == true) {
            this.userDetails.is_change_password = '1';
            localStorage.setItem('userDetails', JSON.stringify(this.userDetails));
            this.submitted = false;
            this.toastr.success(result.msg, '', {
              positionClass: 'toast-top-center',
              timeOut: 1000
            });
            this.logoutUser();
          } else {
            this.toastr.error(result.msg, '', {
              positionClass: 'toast-top-center',
              timeOut: 1000
            });
          }
        }, (err) => {
          console.log(err);
        });
      } else {
        this.toastr.error("New Password and Confirm New Password did not match", '', {
          positionClass: 'toast-top-center',
          timeOut: 10000,
        });
      }
    } else {
      this.toastr.error("Old Password and  New Password are Same.Plz check again", '', {
        positionClass: 'toast-top-center',
        timeOut: 10000,
      });
    }
  }

}
